import React, { useEffect, useRef, useState } from 'react';

const CustomInput = ({ label, type, id, min, max, rows = "1", placeholder, value, name, onBlur, onChange, required, errorText, error }) => {
    // const [textAreaValue, setTextAreaValue] = useState("");

    // const handleInput = (e) => {
    //     const textarea = e.target;
    //     textarea.style.height = "auto"; // Reset the height to calculate scrollHeight
    //     textarea.style.height = `${textarea.scrollHeight}px`; // Set the height to match content
    //     setTextAreaValue(value); // Update state
    // };

    const [textAreaValue, setTextAreaValue] = useState(value || ""); // Initialize state with value prop
    const textareaRef = useRef(null); // Create a ref for the textarea

    // Adjust the height of the textarea based on its content
    const handleInput = (e) => {
        const textarea = e.target;
        textarea.style.height = "auto"; // Reset height to auto
        textarea.style.height = `${textarea.scrollHeight}px`; // Set the height to match content
        setTextAreaValue(textarea.value); // Update state with the textarea value
    };

    // Adjust height whenever value changes (initial load or value change)
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset the height before setting scrollHeight
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set the height based on content
        }
    }, [value]); // Re-run effect whenever the value prop changes

    return (
        <div className="mb-4 form-filled">
            <label htmlFor="email" className="form-label label-title" >{label}{required && <span className="text-danger">*</span>}</label>
            {type === "textarea" ?
                <textarea type={type}
                    className="form-control forminput-custom description-text"
                    style={{ overflow: "hidden", resize: "none" }}
                    rows={rows}
                    id={id}
                    ref={textareaRef} // Attach ref to textarea
                    placeholder={placeholder}
                    value={value}
                    name={name}
                    onInput={handleInput}
                    onBlur={onBlur}
                    onChange={onChange}
                    error={error} /> : <input
                    max={max}
                    min={min}
                    type={type}
                    className="form-control forminput-custom description-text"
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    error={error}
                />}
            {errorText &&
                <small id={`${name}-error`} class="form-text text-danger">
                    {errorText}
                </small>
            }
        </div>
    )
}

export default CustomInput